

import {Directive, ElementRef} from "@angular/core";
@Directive({
    selector: "[sm-sortable]"
})
export class  SMSortable{
    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        jQuery(this.el.nativeElement).sortable( {
            start: function(event, ui) {
                
            },
            stop: function(event, ui) {
                
            }
        });
    }
}